<template>
  <div id="user" class="page">
  <h1>Erziehungsberechtigte/r</h1>
    <div id="userinfo">
      <div class="columns">
        <div class="column">
          <p><input placeholder="Name" name="fullname" v-model="user.fullname"></p>
          <p><input placeholder="E-Mail" name="email" v-model="user.email"></p>
          <p><input placeholder="Mobil" name="mobile" v-model="user.mobile"></p>
          
          <div class="actions">
            <p><a @click.prevent="saveUser" class="button">
            Weiter
            </a></p>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {db} from '../service/firebase';  
export default {
  name: 'User',
  components: {
    
  },
  data () {
      return {
        user: {
            'id': null,
            'kidsname': null,
            'kidscity':null,
            'birthday':null,
            'kids': [ this.$store.state.kid.id ],
            'currentkid': this.$store.state.kid.id
            }
        }
  },
  methods: {
    
    saveUser() {
      var ref =  db.ref('/users').push( this.user )
      this.user.id = ref.key
      
      if(this.user.id) {
        
        var updates = {};
        updates['/kids/' + this.user.currentkid + '/user'] = this.user.id;
        var ref =  db.ref().update(updates)
        
        this.$store.state.user = this.user;
        console.log( this.$store );
        this.$router.push('/party')
      } else {
        console.error('not saved to db!');
      }
      
        //console.log( db.ref('kids/'+ref.key).fetch() );
        //.then(this.$router.push('/'))
    }  
  }
}

</script>
<style>
  input { display: block; width: 100%; padding: 0.6333333em 0.7333333em 0.3333333em; line-height: 1; border: 1px solid #ccc; border-radius: 0.3em; }
</style>
